const sendMessage = (err, message) => {
  console.log(err, message)
  if (err || message) {
    const userAgent = navigator.userAgent.toLowerCase()
    if (userAgent.indexOf('android') !== -1) {
      if (typeof ISTAY_TABLET_APP !== 'undefined' && ISTAY_TABLET_APP) {
        return ISTAY_TABLET_APP.webErrorCallback(err, message)
      }
    }
  }
}

export default sendMessage